export default __webpack_public_path__ + "static/media/logo-ghs.25b189fd.svg";